import moment from "moment";

function momentBase(value, format = "YYYY-MM-DD", fromFormat = '') {
    return moment(value, fromFormat).format(format);
}

export {momentBase}